var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2363_6403"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icon / Sun-light",
    width: 16,
    height: 16,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Icon / Sun-light",
    width: 16,
    height: 16,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2363_6403)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M8.66 0.66C8.66 0.29 8.36 0 8 0C7.63 0 7.33 0.29 7.33 0.66L7.33 1.33C7.33 1.7 7.63 2 8 2C8.36 2 8.66 1.7 8.66 1.33L8.66 0.66ZM3.13 2.19C2.87 1.93 2.45 1.93 2.19 2.19C2.06 2.32 2 2.49 2 2.66C2 2.83 2.06 3 2.19 3.13L2.86 3.8C3.12 4.06 3.54 4.06 3.8 3.8C3.93 3.67 4 3.5 4 3.33C4 3.16 3.93 2.99 3.8 2.86L3.13 2.19ZM13.8 3.13C13.93 3 14 2.83 14 2.66C14 2.49 13.93 2.32 13.8 2.19C13.54 1.93 13.12 1.93 12.86 2.19L12.19 2.86C12.06 2.99 12 3.16 12 3.33C12 3.5 12.06 3.67 12.19 3.8C12.45 4.06 12.87 4.06 13.13 3.8L13.8 3.13ZM8 3.33C6.76 3.33 5.57 3.82 4.69 4.7C3.82 5.57 3.33 6.76 3.33 8C3.33 9.23 3.82 10.42 4.69 11.29C5.57 12.17 6.76 12.66 8 12.66C9.23 12.66 10.42 12.17 11.3 11.29C12.17 10.42 12.66 9.23 12.66 8C12.66 6.76 12.17 5.57 11.3 4.7C10.42 3.82 9.23 3.33 8 3.33ZM5.64 5.64C6.26 5.01 7.11 4.66 8 4.66C8.88 4.66 9.73 5.01 10.35 5.64C10.98 6.26 11.33 7.11 11.33 8C11.33 8.88 10.98 9.73 10.35 10.35C9.73 10.98 8.88 11.33 8 11.33C7.11 11.33 6.26 10.98 5.64 10.35C5.01 9.73 4.66 8.88 4.66 8C4.66 7.11 5.01 6.26 5.64 5.64ZM0.66 7.33C0.29 7.33 0 7.63 0 8C0 8.36 0.29 8.66 0.66 8.66L1.33 8.66C1.7 8.66 2 8.36 2 8C2 7.63 1.7 7.33 1.33 7.33L0.66 7.33ZM14.66 7.33C14.29 7.33 14 7.63 14 8C14 8.36 14.29 8.66 14.66 8.66L15.33 8.66C15.7 8.66 16 8.36 16 8C16 7.63 15.7 7.33 15.33 7.33L14.66 7.33ZM3.8 13.13C3.93 13 4 12.83 4 12.66C4 12.49 3.93 12.32 3.8 12.19C3.54 11.93 3.12 11.93 2.86 12.19L2.19 12.86C2.06 12.99 2 13.16 2 13.33C2 13.5 2.06 13.67 2.19 13.8C2.45 14.06 2.87 14.06 3.13 13.8L3.8 13.13ZM13.8 12.86L13.13 12.19C12.87 11.93 12.45 11.93 12.19 12.19C12.06 12.32 12 12.49 12 12.66C12 12.83 12.06 13 12.19 13.13L12.86 13.8C13.12 14.06 13.54 14.06 13.8 13.8C13.93 13.67 14 13.5 14 13.33C14 13.16 13.93 12.99 13.8 12.86ZM8.66 14.66C8.66 14.29 8.36 14 8 14C7.63 14 7.33 14.29 7.33 14.66L7.33 15.33C7.33 15.7 7.63 16 8 16C8.36 16 8.66 15.7 8.66 15.33L8.66 14.66Z",
    fill: "#718EBF",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.2b091878de71585a69c58ddeba591d81.svg";
export { ForwardRef as ReactComponent };